import { Component, OnInit } from '@angular/core';
import { NavParams, ModalController, PopoverController, ToastController } from '@ionic/angular';
import cloneDeep from 'lodash/cloneDeep';

@Component({
  selector: 'reservationstatus-popover',
  templateUrl: 'stateAddressPopup.html',
  styleUrls: ['stateAddressPopup.scss'],

})

export class stateAddressPopup implements OnInit {

 
  public stateData: any;
  public stateDataCopy: any;
  


  constructor(public navParams: NavParams, private popoverController: PopoverController) {
  }

  ngOnInit() {

    this.stateData = this.navParams.data.stateData;
    this.stateDataCopy = this.navParams.data.stateData;
    
  }

  searchState(search) {
    const term = (search || "").toString().toLowerCase().trim();
    this.stateData = this.stateDataCopy;
    if (!term) {
      return;
    }

    this.stateData = this.stateData.filter(item => {
      return item.stateName.toLowerCase().includes(term);
    });
  }

  addToCartClicked(state) {
    this.popoverController.dismiss(state);
  }

}

